<template>
<div class="chart">
    <line-chart :data="stats" zoom width="110%" height="100%" area />
</div>
</template>

<script>
import Vue from 'vue';
import DrVueEcharts from 'dr-vue-echarts';
Vue.use(DrVueEcharts)
export default {
    props: ['stats']
};
</script>

<style scoped>
.chart {
    width: 100%;
    height: 300px;
}
</style>
